import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '../App.css';
// import '././assets/css/responsive.css';

import Reset from '../pages/clients/Client_reset';
import ForgotPassword from '../pages/clients/Client_forgotpassword';

import ClientAuthGuard from '../components/ClientAuthGuard';
import { ClientAuthProvider } from '../context/ClientAuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import 'primeicons/primeicons.css';
import Client_login from '../pages/clients/Client_login';
import Client_signup from '../pages/clients/Client_signup';

import Comingsoon from '../pages/defaultpages/Comingsoon';
import Client_dashboard from '../pages/clients/Client_dashboard';
function ClientApp() {
  return (
    <ClientAuthProvider>

      <Routes>
        {/* Public Routes */}
        {/* <Route path="/" element={<AuthGuard element={Home} />} /> */}

        {/* <Route path="/" element={<ClientAuthGuard element={Comingsoon} />} /> */}
        <Route path="/" element={<ClientAuthGuard element={Client_login} />} />
        <Route path="/login" element={<ClientAuthGuard element={Client_login} />} />
        <Route path="/signup/:token" element={<ClientAuthGuard element={Client_signup} />} />
        <Route path="/passreset" element={<ClientAuthGuard element={ForgotPassword} />} />
          <Route path="/resetpassword/:token" element={<ClientAuthGuard element={Reset} />} />


        {/* <Route path="comingsoon" element={<ClientAuthGuard element={Comingsoon} allowedRoles={['SuperAdmin']} />} /> */}

        <Route
          path="/dashboard/*"
          element={<ProtectedRoute element={Client_dashboard} allowedRoles={['SuperAdmin','Client']} />}
        />
      </Routes>


    </ClientAuthProvider>
  );
}

export default ClientApp;